
import { AddressInputFields } from "../../address-inputs/AddressInputFields";
import { AddressFields } from "../../AddressFields";
import { AddressDetails } from "@/types/address";
import { useIsMobile } from "@/hooks/use-mobile";

interface AddressSelectionFieldsProps {
  values: AddressDetails;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  prefix: string;
}

export const AddressSelectionFields = ({
  values,
  onChange,
  prefix,
}: AddressSelectionFieldsProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className={isMobile ? "space-y-5" : "space-y-4"}>
      <AddressInputFields
        street={values.street}
        street2={values.street2}
        onChange={onChange}
      />
      <AddressFields
        values={values}
        onChange={onChange}
        prefix={prefix}
      />
    </div>
  );
};
